import { render, staticRenderFns } from "./DataWifiForm.vue?vue&type=template&id=28ad0b1e&scoped=true"
import script from "./DataWifiForm.vue?vue&type=script&lang=js"
export * from "./DataWifiForm.vue?vue&type=script&lang=js"
import style0 from "./DataWifiForm.vue?vue&type=style&index=0&id=28ad0b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad0b1e",
  null
  
)

export default component.exports